
export class LocationError extends Error {
	constructor(code, message) {
		super(message); // Pass the message to the parent Error class
		this.code = code;
	}
};

export const LocationErrorCodes = {
	0: "Error in getting location",
	1: "User rejected location permissions",
	2: "GPS is turned off",
};


export class DeviceLocation {
	static async getDeviceLocation() {
		// Implement actual logic for location retrieval here
		return; // Returning nothing as it's just a placeholder for now
	}
};
